import { render } from "./employee-model.vue?vue&type=template&id=f64b5f80"
import script from "./employee-model.vue?vue&type=script&lang=js"
export * from "./employee-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__